import React from 'react'
import { useNavigate, useLocation } from '@/lib/router-dom'
import clsx from 'clsx'
import PropTypes from 'prop-types'

export const NavigationLink = ({ to, icon, text, disabled, hidden }) => {
  const { goTo } = useNavigate()
  const { currentPath } = useLocation()

  const onClick = e => {
    e.preventDefault()
    if (!disabled) {
      goTo(to)
    }
  }

  const isActive = currentPath.startsWith(to)

  const navigationClass = clsx(
    'navigation-item flex items-center gap-y-3.25 gap-x-2.5 relative w-full cursor-pointer no-underline type-body-1 text-grey-50 hover:text-white hover:bg-theme-50',
    isActive && 'navigation-item--active text-theme-50 bg-theme-95',
    disabled && 'navigation-item--disabled'
  )

  if (hidden) return null

  return (
    <a href={to} onClick={onClick} className={navigationClass} id="navigation-dashboard-tab">
      <div className="w-1.25 h-12 [.navigation-item--active_&]:bg-theme-50" />
      <div className="flex justify-center w-6">{icon}</div>
      <div className="font-avenir relative top-px ml-2.5 flex-1 [.navigation-item--active_&]:font-avenir-heavy">
        {text}
      </div>
    </a>
  )
}

NavigationLink.propTypes = {
  to: PropTypes.string.isRequired,
  icon: PropTypes.node.isRequired,
  text: PropTypes.string.isRequired,
  disabled: PropTypes.bool,
  hidden: PropTypes.bool,
}
